import { getUserRoleFlags } from '../getUserRoleFlags'

/**
 * Whether a user may reverse a payment — refund a paid one or cancel a processing ACH/EFT one.
 *
 * Painters can't, even when they hold `accept-payment:*` (ENG-870). This is the single rule for
 * both: the UI uses it (via `useUser().canReversePayments`) to hide the Refund / Cancel Payment
 * actions, and the API's `refundPayment` / `cancelProcessingPayment` resolvers enforce it.
 */
export function canReversePayments(roles: string[] = []): boolean {
  return !getUserRoleFlags(roles).isPainter
}
